import {AJAX_DATA_TYPE_JSON} from "./recover_consts";

export const getClientFeatures = (data, fr, onCompleteCallback) => {
    $.ajax({
        type: "GET",
        url: "/client/get_client_feature_types/" + data.clientId,
        success: (feature_types) => {
            data.hasNonPF = feature_types['non_protect_flow'] > 0;

            onCompleteCallback();
        },
        dataType: AJAX_DATA_TYPE_JSON,
        contentType: "application/json",
    }).fail(fr.defaultAJAXErrorHandler);
};

// Get more data about a device using its ID
export const getDeviceData = (data, fr, onCompleteCallback) => {
    $.ajax({
        type: "POST",
        url: "/device/get",
        data: JSON.stringify({scopeBy: "DEVICE", forDevice: data.deviceId}),
        success: (device) => {
            data.device = device[0];
            data.applianceId = data.device.appliance_id;
            data.clientId = data.device.client_id;
            onCompleteCallback();
        },
        dataType: AJAX_DATA_TYPE_JSON,
        contentType: "application/json",
    }).fail(fr.defaultAJAXErrorHandler);
};

export const attachRowHandler = (el) => {
    const $el = $(el);
    $el.find('thead th').each(function () {
        $(this).append('<span class="ax-interaction"></span>');
    });

    $el.find('thead th').on('click', function () {
        const $this = $(this);
        const sortDir = ($this.data('dir') === 'asc') ? 'desc' : 'asc';
        const params = {order: sortDir};

        $el.find('th').not(this).data('dir', '');   // reset other columns dirs
        $el.find('.ax-interaction').attr('class', 'ax-interaction'); // remove arrows icons

        if ($this.data('sortby')) {
            params.data = $this.data('sortby');
        }

        $el.find('tbody tr').tsort('td:eq(' + $this.index() + ')', params);
        $this.data('dir', sortDir).find('.ax-interaction').addClass('arrow-' + sortDir);
    });

    $el.find('tbody tr').each(function () {
        const $row = $(this);
        $row.on('click', function () {
            $el.find('tbody tr.selected').removeClass('selected');
            $row.toggleClass('selected');
            $el.find('.btn-primary.disabled').removeClass('disabled');
        });
    });
};

export const attachContactSupportHandler = (data, el, fr) => {
    $(el).find('.blue-note .bottom-link').on('click', function () {
        data.tmp = {previousStep: fr.currentStep};
        fr.goTo('notAvailable');
    });
};

export const attachSelectableHandler = (el, callback) => {
    $(el).find('.flow-selectable-area > a:not(.disabled)').each(function () {
        $(this).on('click', function () {
            $(el).find('.active').removeClass('active');
            $(el).find('.buttons .disabled').removeClass('disabled');
            $(this).addClass('active');

            if (typeof callback === 'function') {
                callback($(this).data());
            }
        });
    });
};

export const toArray = (obj) => {
    return $.map(obj, function (k) {
        return [k];
    });
};

export const showVmsList = (data) => {
    if ($('[data-content="device list"] .inventory').length) {
        $('.header-tab[data-type="VIRTUALIZED"]').click();
    } else {
        tabs_goto('/dashboardumc/inventory/' + data.clientId + '/VIRTUALIZED');
    }
};

export const getExposedMount = (data, on_success) => {
    if (!data.recovery.appliance_id && data.applianceId) {
        data.recovery.appliance_id = data.applianceId;
    }
    if (!data.recovery.device_id && data.deviceId) {
        data.recovery.device_id = data.deviceId;
    }

    $.ajax({
        type: "POST",
        url: "/ra_ajax/is_disk_from_failover",
        data: JSON.stringify({aid: data.recovery.appliance_id, device_id: data.recovery.device_id}),
        dataType: AJAX_DATA_TYPE_JSON,
        contentType: "application/json"
    }).done(on_success).fail(function (response) {
        console.log('get exposed mount failed', response);
    });
};

export const getFormattedDateTime = (date) => {
    const hh = date.getHours();
    const mm = date.getMinutes();
    const ampm = hh >= 12 ? 'pm' : 'am';
    return date.getFormattedDatePoint() + ' at ' + (hh % 12) + ':' + (mm < 10 ? '0' : '') + mm + ampm;
};

export const startRunbook = (fr, clientId, runbookId, voType, runbookPassword, autostopAfterMinutes, successCallback, failCallback) => {
    const data = {
      client_id: clientId,
      runbook_id: runbookId,
      vo_type: voType
    };
    if (runbookPassword !== null) {
      data.password = runbookPassword;
    }
    if (autostopAfterMinutes !== null) {
      data.autostop_after_minutes = autostopAfterMinutes;
    }
    $.ajax({
        url: '/runbook/actions/start',
        type: 'POST',
        data: data,
        dataType: AJAX_DATA_TYPE_JSON,
        success: function (rv, status) {
            if (rv.is_error) {
                if (typeof failCallback === 'function') {
                    failCallback(rv, status);
                }
            } else {
                if (typeof successCallback === 'function') {
                    successCallback(rv, status);
                }
            }
        }
    }).fail(fr.defaultAJAXErrorHandler);
};

export const getUrl = (data, call) => {
    let path = '/api/filebrowsing/' + call + '/' + data.recovery.appliance_id
        + '/' + data.recovery.device_asid + '/' + data.recovery.job_id + '/';
    if (call === 'download') {
        path += data.recovery.point + '/' + data.filemountUseId;
    } else {
        path += data.recovery.drive;
    }
    return path;
};

export const isExportToDisk = (data) => {
    return (data.recovery.virtualization && data.recovery.virtualization.location
        && (data.recovery.virtualization.location === "vm-export" || data.recovery.virtualization.location === "vhd-export"
            || data.recovery.virtualization.location === "vhdx-export"));
};

// Do not need to recover folder if any child file or folder selected
export const parentChangeColor = (item) => {
    if (item.getParentColumn().parentItem !== undefined) {
        const parent_index = item.getParentColumn().parentItem.opts.index;
        const parent_div = $("#" + item.getParentColumn().id).prev().attr('id');
        const parent_folder = $("#" + parent_div).find(".folder-selected#" + parent_div + "-item" + parent_index);
        const attr = parent_folder.hasClass('folder-selected');
        if (attr) {
            parent_folder.removeClass('folder-selected').removeClass('cvl-column-item-selected');
            parent_folder.attr("style", 'background-color: #F1F1F1 !important');
        }
    }
};

export const parentCounterDecrement = (array_counter, temp_folders, temp_files) => {
    let target_array;
    let v;
    for (v = 0; v < array_counter;) {
        if (temp_files) {
            target_array = temp_files;
        } else {
            target_array = temp_folders;
        }

        const parent_folder = target_array[v].substring(0, target_array[0].lastIndexOf('/'));
        if ($.inArray(parent_folder, temp_folders) !== -1) {
            array_counter--;
            const index = target_array.indexOf(target_array[v]);
            if (index >= 0) {
                target_array.splice(index, 1);
            }
            $('.file-select-counter').html('<strong>Files selected: ' + array_counter + '</strong>').css('visibility', 'visible');
        } else {
            v++;
        }
    }
    return array_counter;
};

export const voErrorClick = (el, fr) => {
    const client = $(el).attr('data-client-id');
    const vo = $(el).attr('data-vo-id');
    fr.close();
    if (typeof client !== undefined && vo !== undefined) {
        tabs_goto('/client/details/' + client + '/' + vo);
    }
};

export const setAzureExportState = (data, fr, successCallback) => {
    const stepsData = [];
    let url = '';

    if (data.clientId) {
        url = `/azure_export/set_azure_client/${data.clientId}`;
    } else if (data.deviceId) {
        url = `/azure_export/set_azure_device/${data.deviceId}`;
    } else if (data.snapshotName) {
        url = `/azure_export/set_azure_restore_point/${data.snapshotName}`;
    } else if (data.subscriptionId && data.subscriptionName && data.resourceGroupName) {
        url = `/azure_export/set_azure_subscription/${data.subscriptionId}/${data.subscriptionName}/${data.resourceGroupName}`;
    } else if (data.storageAccountId) {
        const storageAccountSegments = data.storageAccountId.split('/');
        const storageAccountName = storageAccountSegments[storageAccountSegments.length - 1];
        url = `/azure_export/set_azure_storage_account/${storageAccountName}/${data.storageAccountRegion}`;
    }

    return $.ajax({
        url: url,
        type: 'GET',
        success: function (rv, status) {
            if (rv.ok) {
                if (typeof successCallback === 'function') {
                    successCallback(rv, status);
                }
            }
        }
    }).fail(fr.defaultAJAXErrorHandler);
}
